import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaskedInput from "../masked-input";
import DateInput from "../date-input";
import TextAreaInput from "../text-area-input.vue";
import MultipleOptionsInput from "../multiple-options-input.vue";
import PriorEncumbrancesInput from "./bc-prior-encumbrances-input.vue";
import NoYesExplainInput from "../no-yes-explain-input.vue";
import { pull } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "BCOptionsInput",
  components: {
    MaskedInput,
    DateInput,
    TextAreaInput,
    MultipleOptionsInput,
    NoYesExplainInput,
    PriorEncumbrancesInput
  },
  props: {
    prompt: {
      type: String,
      default: ""
    },
    colSize: {
      type: String,
      default: "6"
    },
    value: {
      type: null,
      default: null
    },
    options: {
      type: Array,
      required: true
    },
    margin: {
      type: [String, Number],
      default: "0"
    },
    multi: {
      type: Boolean,
      default: false
    },
    articleClass: {
      type: String,
      default: ""
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    cols: {
      type: String,
      default: "1"
    },
    rows: {
      type: String,
      default: "1"
    }
  },
  data() {
    const defaultInputVal = this.options.some(option => option.multi) ? [] : {
      option: "",
      text: "",
      secondOption: "",
      secondOptionText: "",
      date: ""
    };
    return {
      answer: this.value || defaultInputVal
    };
  },
  computed: {
    checkedMap() {
      var _this$options$map$red, _context, _context2;
      return (_this$options$map$red = _reduceInstanceProperty(_context = _mapInstanceProperty(_context2 = this.options).call(_context2, opt => opt.value)).call(_context, (acc, curr) => {
        var _context3;
        if (_findInstanceProperty(_context3 = this.answer).call(_context3, element => element.value && element.value === curr || element === curr)) acc[curr] = true;else acc[curr] = false;
        return acc;
      }, {})) != null ? _this$options$map$red : {};
    }
  },
  watch: {
    "answer.option"() {
      this.answer.text = "";
      this.answer.secondOption = "";
    },
    value() {
      this.answer = this.value;
    }
  },
  methods: {
    handleChange() {
      this.$emit("input", this.answer);
    },
    noYesInputValue() {
      var _context4, _context5;
      const values = _mapInstanceProperty(_context4 = this.options).call(_context4, opt => opt.value);
      return _filterInstanceProperty(_context5 = this.answer).call(_context5, element => element.value && _includesInstanceProperty(values).call(values, element.value) || _includesInstanceProperty(values).call(values, element));
    },
    textareaValue(optionValue) {
      const obj = this.findElement(this.answer, optionValue);
      return obj ? obj.text : "";
    },
    handleMultiChange(event) {
      const {
        value,
        name
      } = event.target;
      const element = this.findElement(this.answer, value);
      if (element) {
        this.answer = pull(this.answer, element);
      } else {
        if (value === "") this.answer.push(name);else this.answer.push(value);
      }
      this.$emit("input", this.answer);
    },
    findElement(arr, value) {
      return _findInstanceProperty(arr).call(arr, elem => elem.value && elem.value === value || elem === value);
    },
    marginByIndex(idx) {
      return idx + 1;
    },
    optionWrapperClass(option) {
      return option.multi ? "pretty p-icon p-jelly p-smooth p-curve col-xs-12" : "fe-option col-xs-12";
    },
    inputComponent(inputType = "text") {
      const inputComponentParser = {
        text: MaskedInput,
        date: DateInput,
        textarea: TextAreaInput,
        multipleOptions: MultipleOptionsInput,
        priorEncumbrances: PriorEncumbrancesInput
      };
      return inputComponentParser[inputType];
    },
    handleExplainChange(value) {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (typeof value == "object") {
        this.answer.text = value.target.value;
      } else {
        if (value.match(dateRegex)) this.answer.date = value;else this.answer.text = value;
      }
      this.handleChange();
    },
    handleNoYesInput(optionValue, componentAnswer) {
      const obj = this.findElement(this.answer, optionValue);
      this.answer = pull(this.answer, obj);
      this.answer.push(_objectSpread({
        value: optionValue,
        text: obj ? obj.text : ""
      }, componentAnswer));
      this.handleChange();
    },
    handleTextareaChange(optionValue, textareaText) {
      var _obj$option, _obj$textareaValue, _obj$ifYesAnswer;
      var obj = this.findElement(this.answer, optionValue);
      this.answer = pull(this.answer, obj);
      this.answer.push({
        value: optionValue,
        text: textareaText.target.value,
        option: (_obj$option = obj.option) != null ? _obj$option : "",
        extraComponentText: (_obj$textareaValue = obj.textareaValue) != null ? _obj$textareaValue : "",
        ifYesAnswer: (_obj$ifYesAnswer = obj.ifYesAnswer) != null ? _obj$ifYesAnswer : ""
      });
      this.handleChange();
    },
    handleSecondOptionChange(value) {
      this.answer.secondOption = value.secondOption;
      this.answer.secondOptionText = value.secondOptionText;
      this.handleChange();
    },
    handleInput() {
      this.answer = [];
      this.handleChange();
    },
    getOrder(position) {
      const leftSide = -1;
      const rightSide = 2;
      return position == "left" ? leftSide : rightSide;
    }
  }
});